import React from "react";

import About from "./About";
import Products1 from "./Products1";
import Contactus1 from "./Contactus1";
import Footer1 from "../components/Footer1";

import HeroSection3 from "../components/HeroSection3";
import Quality1 from "../components/Quality1";
import Adbluedetails from "./Adbluedetails";
import Dealership from "./Dealership";

const Home = () => {
  return (
    <span className="home">
      {/* <br></br> */}
      <HeroSection3 />
      
      

      <div className="container">
      <Adbluedetails />
      
        <br />
        <Products1 />
        
        <br></br>
        <About />
        <br></br>
        <Dealership/>
        <br />
      </div>
      {/* <Quality1 /> */}
      <Contactus1 />
      <br></br>
      <Footer1 />
    </span>
  );
};

export default Home;
